<div class="container-margin">
  <h1 class="header">{{ title }}</h1>
  <form [formGroup]="templateForm">
    <div class="form-groups">
      <!-- Template Name -->
      <div class="form-group template-name">
        <mat-form-field appearance="outline">
          <mat-label>Template Name</mat-label>
          <input
            matInput
            type="text"
            name="name"
            formControlName="name"
            autocomplete="off"
            required
          />
        </mat-form-field>
      </div>

      <div class="info-text form-group">
        <p>
          {{ translationService.getFprTemplateMappingHelpText() }}
        </p>
      </div>

      <!-- Core Identifiers -->
      <div class="form-group">
        <mat-form-field appearance="outline">
          <mat-label>SKU</mat-label>
          <input
            matInput
            type="text"
            formControlName="sku"
            autocomplete="off"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ translationService.getSupplierText() }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="supplier"
            autocomplete="off"
            required
          />
        </mat-form-field>
      </div>

      <!-- Quantities -->
      <div class="section-header">
        <h2>{{ translationService.getQuantitiesText() }}</h2>
      </div>
      <div class="form-group">
        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getQtyManufacturedInCanadaText()
          }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyManufactured"
            autocomplete="off"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ translationService.getQtyImportedText() }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyImported"
            autocomplete="off"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getQtyPlacedOnMarketText()
          }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyPlacedOnMarket"
            autocomplete="off"
            required
          />
        </mat-form-field>
      </div>

      <div class="form-group">
        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getWasteGeneratedAtPremisesText()
          }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyWasteGeneratedAtPremises"
            autocomplete="off"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getCollectedAtEndOfLifeText()
          }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyCollectedAtEndOfLife"
            autocomplete="off"
            required
          />
        </mat-form-field>
      </div>

      <!-- Diversion Pathways -->
      <div class="section-header">
        <h2>Diversion Pathways</h2>
      </div>
      <div class="form-group">
        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getDivertedMechanicalRecyclingText()
          }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyDivertedMechanicalRecycling"
            autocomplete="off"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getDivertedChemicalRecyclingText()
          }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyDivertedChemicalRecycling"
            autocomplete="off"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getDivertedProcessingIntoChemicalsFuelsText()
          }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyDivertedProcessingIntoChemicalsFuels"
            autocomplete="off"
            required
          />
        </mat-form-field>
      </div>

      <div class="form-group">
        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getDivertedCompostingText()
          }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyDivertedComposting"
            autocomplete="off"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getDivertedDirectReuseText()
          }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyDivertedDirectReuse"
            autocomplete="off"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getDivertedRefurbishmentText()
          }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyDivertedRefurbishment"
            autocomplete="off"
            required
          />
        </mat-form-field>
      </div>

      <div class="form-group">
        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getDivertedRemanufacturingText()
          }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyDivertedRemanufacturing"
            autocomplete="off"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getDivertedRepairText()
          }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyDivertedRepair"
            autocomplete="off"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getDivertedIncinerationIndustrialProcessesText()
          }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyDivertedIncinerationIndustrialProcesses"
            autocomplete="off"
            required
          />
        </mat-form-field>
      </div>

      <div class="form-group">
        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getDivertedIncinerationWithEnergyRecoveryText()
          }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyDivertedIncinerationWithEnergyRecovery"
            autocomplete="off"
            required
          />
        </mat-form-field>
      </div>

      <!-- Final Disposal -->
      <div class="section-header">
        <h2>Final Disposal</h2>
      </div>
      <div class="form-group">
        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getFinalDisposalIncinerationNoEnergyRecoveryText()
          }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyFinalDisposalIncinerationNoEnergy"
            autocomplete="off"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getFinalDisposalLandfillText()
          }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyFinalDisposalLandfill"
            autocomplete="off"
            required
          />
        </mat-form-field>
      </div>

      <!-- Provincial Splits -->
      <div class="section-header">
        <h2>Provincial / Territorial Splits</h2>
      </div>
      <div class="form-group">
        <mat-form-field appearance="outline">
          <mat-label>{{ translationService.getQtyAlbertaText() }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyAlberta"
            autocomplete="off"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getQtyBritishColumbiaText()
          }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyBritishColumbia"
            autocomplete="off"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ translationService.getQtyManitobaText() }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyManitoba"
            autocomplete="off"
            required
          />
        </mat-form-field>
      </div>

      <div class="form-group">
        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getQtyNewBrunswickText()
          }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyNewBrunswick"
            autocomplete="off"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getQtyNewfoundlandAndLabradorText()
          }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyNewfoundlandAndLabrador"
            autocomplete="off"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getQtyNorthwestTerritoriesText()
          }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyNorthwestTerritories"
            autocomplete="off"
            required
          />
        </mat-form-field>
      </div>

      <div class="form-group">
        <mat-form-field appearance="outline">
          <mat-label>{{ translationService.getQtyNovaScotiaText() }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyNovaScotia"
            autocomplete="off"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ translationService.getQtyNunavutText() }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyNunavut"
            autocomplete="off"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ translationService.getQtyOntarioText() }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyOntario"
            autocomplete="off"
            required
          />
        </mat-form-field>
      </div>

      <div class="form-group">
        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getQtyPrinceEdwardIslandText()
          }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyPrinceEdwardIsland"
            autocomplete="off"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ translationService.getQtyQuebecText() }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyQuebec"
            autocomplete="off"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getQtySaskatchewanText()
          }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtySaskatchewan"
            autocomplete="off"
            required
          />
        </mat-form-field>
      </div>

      <div class="form-group">
        <mat-form-field appearance="outline">
          <mat-label>{{ translationService.getQtyYukonText() }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="qtyYukon"
            autocomplete="off"
            required
          />
        </mat-form-field>
      </div>
    </div>

    <div class="actions">
      <button
        mat-raised-button
        extended
        color="primary"
        class="action-item"
        (click)="onSubmit()"
      >
        <mat-icon>add</mat-icon>
        {{ translationService.getSaveText() }}
      </button>
      <button
        type="button"
        mat-stroked-button
        extended
        color="primary"
        class="action-item"
        (click)="onReset()"
      >
        <mat-icon>refresh</mat-icon>
        Reset
      </button>
    </div>
  </form>
</div>
